import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/*
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * NAGŁÓWEK EKRANU — przeniesiony z `.naglowek-ekranu` makiety
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * PO CO ISTNIEJE. Makieta trzyma tytuł ekranu i STEROWANIE WIDOKIEM w jednym wierszu: tytuł
 * z podtytułem po lewej, rozpychacz, wybór wariantu dociągnięty do prawej krawędzi. Produkt
 * układał to pionowo — tytuł, dwa akapity, a pod nimi filtr okna jako osobna karta na pełną
 * szerokość. Różnica nie jest kosmetyczna: filtr rozciągnięty na 1160 px czyta się jak
 * zawartość ekranu, a nie jak jego ustawienie, i odsuwa pierwszą liczbę o kolejny ekran w dół.
 *
 * DLACZEGO WSPÓLNY KOMPONENT, A NIE POPRAWKA NA JEDNYM EKRANIE. Szesnaście ekranów pisało
 * `<Typography variant="h4" component="h1">` ręcznie, a dwanaście z nich stawiało pod spodem
 * `<DateRangeFilter />` w tej samej, niezgodnej z makietą formie. To była jedna brakująca
 * warstwa powtórzona dwanaście razy — dokładnie ten sam kształt usterki co `Karta` i `PasSekcji`
 * w R5-15-014.
 *
 * `align-items: flex-end` jest z makiety i jest celowe: tytuł bywa jedno- lub dwuwierszowy,
 * a sterowanie ma stać na tej samej linii bazowej co dół tytułu, nie na jego górze.
 *
 * PODTYTUŁ MA 62ch. Tyle ma `.podtytul-ekranu` w makiecie. Produkt używał 68ch i 78ch na
 * przemian, przez co dwa ekrany obok siebie łamały tekst w innym miejscu.
 */

export function NaglowekEkranu({
  tytul,
  opis,
  akcja,
  kartaId,
}: {
  tytul: ReactNode;
  opis?: ReactNode;
  /**
   * Sterowanie widokiem dociągnięte do prawej krawędzi — w makiecie to `.wybor-wariantu`.
   * Zwykle `<DateRangeFilter wariant="naglowek" />`.
   */
  akcja?: ReactNode;
  /** Stabilny adres karty dla walidacji DOM — ta sama konwencja co w `Karta` i `PlytaGlowna`. */
  kartaId?: string;
}) {
  return (
    <Box
      data-cc-card-id={kartaId}
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 'var(--o4)',
        mb: 'var(--o5)',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" component="h1">
          {tytul}
        </Typography>
        {opis ? (
          <Typography
            sx={{
              mt: 'var(--o2)',
              maxWidth: '62ch',
              fontSize: 'var(--st-maly)',
              color: 'var(--tekst-2)',
            }}
          >
            {opis}
          </Typography>
        ) : null}
      </Box>

      {/* `.rosnij` z makiety. Bez rozpychacza sterowanie przykleja się do tytułu, gdy tytuł
          jest krótki, i wygląda jak jego część. */}
      {akcja ? (
        <>
          <Box sx={{ flex: 1 }} />
          {akcja}
        </>
      ) : null}
    </Box>
  );
}
